import { render, staticRenderFns } from "./PackagesPage.vue?vue&type=template&id=113e92b3&"
import script from "./PackagesPage.vue?vue&type=script&lang=ts&"
export * from "./PackagesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports